<template>
  <div>
    <user-detail-title first-bread="公司招聘"
                       second-bread="公司招聘修改"
                       first-url="/user/recruitment"
                       title-name="公司招聘修改"
    ></user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="招聘岗位">
          <el-input v-model="Clist.post" :placeholder="LookData.post"></el-input>
        </el-form-item>
        <el-form-item label="薪资">
          <el-input v-model="Clist.salary" :placeholder="LookData.salary"></el-input>
        </el-form-item>
        <el-form-item label="岗位职责">
          <el-input type="textarea" :rows="4" v-model="Clist.duty" :placeholder="LookData.duty"></el-input>
        </el-form-item>
        <el-form-item label="岗位要求">
          <el-input type="textarea" :rows="4" v-model="Clist.demand" :placeholder="LookData.demand"></el-input>
        </el-form-item>
        <el-form-item label="职位详情">
          <el-input type="textarea" :rows="4" v-model="Clist.postDetail" :placeholder="LookData.postDetail"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="Clist.email" type="email" :placeholder="LookData.email"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="Clist.phoneNumber" type="tel" :placeholder="LookData.phoneNumber"></el-input>
        </el-form-item>
        <el-button @click="handleChange()">修改</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "@/views/User/Common/UserDetailTitle";
  import UserDetailBase from "@/views/User/Common/UserDetailBase";
  export default {
    name: "RecruitmentChange",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
        Clist: {
          'id':this.$route.params.id,
          'post':null,
          'salary':null,
          'duty':null,
          'demand':null,
          'email':null,
          'phoneNumber':null,
          'postDetail': null
        },//表示Change// 添加的数据
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetLookData(id){
        this.$axios.get('/api/job/getById',{params:{
            id:id
          }}).then(res=>{
          this.LookData=res.data.data
        })
      },
      GetUrlList(file){
        this.Clist.logoUrl=file.data;
      },
      handleChange(){
        if(this.Clist.post && this.Clist.post){
          this.$axios.post('/api/job/update',this.Clist).then(res=>{
            if(res.data.success == true){
              this.Clist= {
                'id':this.$route.params.id,
                'post':null,
                'salary':null,
                'duty':null,
                'demand':null,
                'email':null,
                'phoneNumber':null,
                'postDetail': null
              }//表示Add添加的数据,
              this.$message({
                message:'修改成功',
                type:'success'
              })
            }
          })
        } else {
          this.$message.warning('岗位和薪资都要填写')
        }

      }
    },
  }
</script>

<style scoped>

</style>